// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vz-progress-bar{align-items:center;display:flex;justify-content:space-between;width:100%}.vz-progress-bar-track{background-color:hsla(0,0%,100%,.2);border-radius:1px;height:4px;width:100%}.vz-progress-bar-thumb{border-radius:1px;height:100%}.vz-progress-bar-label{font-size:.8em;margin:0 0 0 8px;text-align:right}.vz-progress-bar-label:after{content:\"%\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
